import React, { useState } from "react";
import "./styles.scss";
import styles from "../Products/productlist.module.scss";
import { SelectorOption } from "./SelectorOption";
import { AttributeOption, ProductAttribute } from "../Products/types";

type SelectorProps = {
  options: AttributeOption[];
  onSelected: (option: AttributeOption | undefined) => void;
  DisplayZero: string;
  attribute: ProductAttribute;
};

export const FancySelector: React.FC<SelectorProps> = ({
  options,
  onSelected,
  DisplayZero,
  attribute,
}) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);

  function handleOptionChange(option: AttributeOption): void {
    setSelectedId(option.Id);
    onSelected(option);
  }
  const label = attribute.Name;
  const groupName = `attribute-${attribute.Id}`;

  return (
    <fieldset className="fancy-selector">
      <legend className={`fancy-selector__title ${styles.attributeName}`}>
        {label}
      </legend>
      {options.map((opt) => (
        <SelectorOption
          key={opt.Id}
          Option={opt}
          isSelected={opt.Id === selectedId}
          DisplayZero={DisplayZero}
          groupName={groupName}
          onChange={() => handleOptionChange(opt)}
        />
      ))}
    </fieldset>
  );
};
